/**
 * Выбор диалога для начального отображения в DialogsTab (TASKNEIROKLYUCH-647).
 *
 * Приоритет:
 *   1. Если в URL задан requestedDialogId и он найден в списке — выбираем его (deep-link из уведомления).
 *   2. Если requestedDialogId задан, но не найден — fallback на первый (диалог мог быть в другой кампании,
 *      в архивах, либо рекрутер зашёл по устаревшей ссылке).
 *   3. Если уже есть выбранный диалог (currentlySelected) — не меняем.
 *   4. Если нет requestedDialogId и нет currentlySelected — первый диалог в списке.
 *   5. Если список пуст — null.
 */

export interface DialogLike {
	id: string | number;
}

export function selectInitialDialog<T extends DialogLike>(
	dialogs: T[],
	requestedDialogId: string | null | undefined,
	currentlySelected: T | null,
): T | null {
	if (!dialogs || dialogs.length === 0) return null;
	if (requestedDialogId) {
		const found = dialogs.find((d) => String(d.id) === String(requestedDialogId));
		if (found) return found;
		return dialogs[0];
	}

	if (currentlySelected) {
		const stillVisible = dialogs.find((d) => String(d.id) === String(currentlySelected.id));
		if (stillVisible) return stillVisible;
	}
	return dialogs[0];
}
